import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback } from "react";
import { ItemType } from "sprout-graphql";
import { useIsMyTasksPageOnboard, useIsReadLaterPageOnboard, useIsTopicPageOnboard } from "@sprout/hooks/dist/onboard";
import { getIsLargePointerDevice } from "sprout-ui-dom/dist/utils";
import { getPostAuthorization } from "@sprout/client-components/dist/Post";
import { useCurrentUser } from "@sprout/client-graphql";
import { useTopicPage } from "../TopicPageContext";
import { useTopicPageViewsTopicEditor } from "./TopicPageViewsTopicEditorContext";
export default function useTopicPageViewsTopicEditorGlobalHandlers({ topic  }) {
    const { id , rootTopicOrSelf  } = topic;
    const { special  } = rootTopicOrSelf || {};
    const { dispatch  } = useTopicPageViewsTopicEditor();
    const [, onboardTopicPage] = useIsTopicPageOnboard();
    const [, onboardMyTasksPage] = useIsMyTasksPageOnboard();
    const [, onboardReadLaterPage] = useIsReadLaterPageOnboard();
    const currentUser = useCurrentUser();
    const currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
    const { isPartOfTopic , disabled  } = useTopicPage();
    useActionRegistryGlobalHandler([
        "ADD_POST",
        "ADD_DIVIDER"
    ], useCallback((items, _event, command)=>{
        var ref;
        if (items.length > 1) return false;
        // Mark onboarding stuffs
        if (command === "ADD_POST") {
            if (special === "MY_TASKS") onboardMyTasksPage();
            else if (special === "INBOX") onboardReadLaterPage();
            else onboardTopicPage();
        }
        if (items.length === 0) {
            _event === null || _event === void 0 ? void 0 : _event.preventDefault();
            dispatch({
                type: "SET_EDITOR",
                payload: {
                    editor: command === "ADD_POST" ? "CREATE_POST" : "CREATE_DIVIDER",
                    editorPosition: id,
                    variant: getIsLargePointerDevice() ? "desktop" : "mobile"
                }
            });
            return true;
        }
        const [activeItem] = items;
        // Do not allow new post creation if section is close
        if (activeItem.type === ItemType.Topic) {
            var ref1;
            const section = activeItem;
            if (((ref1 = section.userPreferences) === null || ref1 === void 0 ? void 0 : ref1.mainIsOpen) === false) return false;
        }
        _event === null || _event === void 0 ? void 0 : _event.preventDefault();
        dispatch({
            type: "SET_EDITOR",
            payload: {
                editor: command === "ADD_POST" ? "CREATE_POST" : "CREATE_DIVIDER",
                editorPosition: activeItem.id,
                parentId: activeItem.type === ItemType.Post ? (ref = activeItem.parentTopic) === null || ref === void 0 ? void 0 : ref.id : undefined,
                variant: getIsLargePointerDevice() ? "desktop" : "mobile"
            }
        });
        return false;
    }, [
        dispatch,
        id,
        onboardMyTasksPage,
        onboardReadLaterPage,
        onboardTopicPage,
        special, 
    ]), {
        skip: !currentUser || disabled || !isPartOfTopic
    });
    /**
   * Why this this logic here instead of `performSingularAction` in
   * `TopicPageViewsTopicListPosts`?
   *
   * This is because this singular action needs to be clickable from the
   * `MultiselectMenu`. And for the `MultiselectMenu` to render this action,
   * it needs to use the `multiselect` option in `actionRegistry`.
   */ useActionRegistryGlobalHandler("EDIT_POST_DESCRIPTION", useCallback((activeItems)=>{
        activeItems.length;
        const [activeItem] = activeItems;
        const variant = getIsLargePointerDevice() ? "desktop" : "mobile";
        const authorization = getPostAuthorization({
            post: activeItem,
            currentUserId: currentUserId
        });
        if (!authorization.edit) return false;
        dispatch({
            type: "SET_EDITOR",
            payload: {
                editor: "EDIT_POST_DESCRIPTION",
                editorPosition: activeItem.id,
                variant
            }
        });
        return true;
    }, [
        currentUserId,
        dispatch
    ]), {
        skip: !currentUser
    });
};
